import "./link.scss";

import { ReactComponent as LinkIcon } from "./link.svg";

import { Link as DomLink } from "react-router-dom";

function Link(props) {
  const handleClick = (e) => {
    e.preventDefault();

    if (typeof props.onClick === "function") {
      props.onClick(e);
    }
  };

  if (props.internLink) {
    return (
      <DomLink
        to={props.href}
        className={`link${props.dark ? ` link--dark` : ""}${
          props.className ? ` ${props.className}` : ""
        }`}
        onClick={() => window.scrollTo(0, 0)}
        id={props.id ? props.id : undefined}
        aria-label={props.ariaLabel ? props.ariaLabel : null}
      >
        {props.text}
        {props.children}
      </DomLink>
    );
  }

  return (
    <a
      className={`link${props.dark ? ` link--dark` : ""}${
        props.className ? ` ${props.className}` : ""
      }`}
      href={props.href}
      target={props.target ? props.target : "_blank"}
      id={props.id ? props.id : undefined}
      rel="noopener noreferrer"
      download={props.download ? "" : undefined}
      onClick={typeof props.onClick === "function" ? handleClick : null}
      aria-label={props.ariaLabel ? props.ariaLabel : null}
    >
      {props.text}
      {props.children}

      {props.withIcon ? (
        <div className="link__icon">
          <LinkIcon />
        </div>
      ) : null}
    </a>
  );
}

export default Link;
